export default {"src":"/_next/static/media/icon-err-toast.68edab9b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};